document.addEventListener('DOMContentLoaded', function () {
  var rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  var headings = Array.from(rte.querySelectorAll('h2'));
  if (!headings.length) return;

  headings.forEach(function (h2) {
    var siblings = [];
    var next = h2.nextElementSibling;
    while (next && next.tagName !== 'H2') {
      siblings.push(next);
      next = next.nextElementSibling;
    }

    if (!siblings.length) return;

    var panel = document.createElement('div');
    panel.className = 'policy-accordion__panel';
    h2.after(panel);
    siblings.forEach(function (el) { panel.appendChild(el); });

    h2.classList.add('policy-accordion__trigger');
    h2.setAttribute('aria-expanded', 'false');

    h2.addEventListener('click', function () {
      var isOpen = h2.getAttribute('aria-expanded') === 'true';
      h2.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});
